var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.loading === true)?_c('div',{staticClass:"z-10 fixed top-0 left-0 right-0 bottom-0 w-100 h-100 bg-white flex justify-center items-center"},[_c('img',{attrs:{"src":"/spinner.gif","alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }